"use client";
// import { useState, useEffect } from "react";
import { motion } from "motion/react";
import { Trees, Leaf } from "lucide-react";

export function LoadingPanel() {
  // const [isVisible, setIsVisible] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => { setIsVisible(false); }, 2500);
  //   return () => clearTimeout(timer);
  // }, []);

  // if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[9999] bg-gradient-to-br from-[#F3EBDD] via-[#D8C4A8] to-[#F3EBDD] flex items-center justify-center"
    >
      <div className="relative">
        <motion.div
          animate={{ y: [0, -20, 0], rotate: [0, 10, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -top-10 -left-10 text-[#7A4A1D]/20"
        >
          <Leaf className="w-16 h-16" />
        </motion.div>
        <motion.div
          animate={{ y: [0, 15, 0], rotate: [0, -10, 0] }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.5,
          }}
          className="absolute -bottom-10 -right-10 text-[#3E6B4E]/20"
        >
          <Leaf className="w-20 h-20" />
        </motion.div>
        <div className="text-center">
          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 15 }}
            className="mb-6 flex justify-center"
          >
            <div className="relative">
              <Trees className="w-24 h-24 text-[#3E6B4E]" />
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute inset-0 bg-[#3E6B4E]/20 rounded-full blur-2xl"
              />
            </div>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-5xl mb-4 text-[#5A3A1E]"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            ARANYA
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="text-[#7A4A1D] text-lg tracking-wider uppercase"
          >
            Nature Awaits
          </motion.p>
          <div className="mt-8 flex justify-center gap-2">
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                animate={{ y: [0, -10, 0] }}
                transition={{
                  duration: 0.6,
                  repeat: Infinity,
                  delay: i * 0.15,
                }}
                className="w-2 h-2 bg-[#3E6B4E] rounded-full"
              />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
